import { getEnv } from '@config';
import { axiosInstance } from '@services/base-service';

const { promotionTokenTimeout: timeoutToken } = getEnv();

const promotionsUri = '/andes/bff/promotions';

const buildPromotionsUrl = () => `${promotionsUri}/api/v1/promotions`;

const buildAuthUrl = (productType) =>
  `${promotionsUri}/api/v1/promotions/auth?product=${productType}`;

export const getPromotions = async () => axiosInstance.getInstance().get(buildPromotionsUrl());

export const getTokenForCreditLine = async () =>
  axiosInstance.getInstance().get(buildAuthUrl('LC'), { timeout: timeoutToken });

export const getTokenForCreditWithAccount = async () =>
  axiosInstance.getInstance().get(buildAuthUrl('CA'), { timeout: timeoutToken });

export const getTokenForInstallmentCredit = async () =>
  axiosInstance.getInstance().get(buildAuthUrl('CC'), { timeout: timeoutToken });
